const REGION_DEFINITIONS = {
  wellington: {
    id: "wellington",
    label: "Wellington",
    domain: "catchy.nz",
    allowedOrigin: "https://catchy.nz",
    timezone: "Pacific/Auckland",
    map: {
      center: [174.7762, -41.2865],
      bounds: [174.4, -41.6, 175.2, -40.8],
    },
    branding: {
      appName: "Catchy",
      storagePrefix: "catchy",
    },
    publicPages: {
      aboutDescription:
        "Find out more about Wellington's favourite free public transport app.",
      agencyName: "Metlink",
      modesLabel: "buses, trains, ferries, and cable cars",
      appsDescription:
        "Apps are available for Android and iPhone, with Apple Watch and Wear OS companion apps.",
      googlePlayUrl:
        "https://play.google.com/store/apps/details?id=nz.catchy.twa",
      appleStoreUrl:
        "https://apps.apple.com/nz/app/catchy-public-transport/id1595272468",
      includeWatchCredit: true,
      includeWearCredit: true,
      dataCredits: [
        {
          name: "Metlink",
          href: "https://www.metlink.org.nz/",
          apiHref: "https://opendata.metlink.org.nz/",
        },
      ],
    },
    data: {
      provider: "metlink",
      databaseEnv: "POSTGRESQL_CONNECTION_STRING",
      gtfsSchema: "gtfs_wellington",
      regionSchema: "wellington",
      searchPath: "gtfs_wellington,wellington,shared,public",
      hasRealtimeIngest: true,
      hasDataRepairLayer: true,
    },
    capabilities: {
      realtime: true,
      staticGtfsOnly: false,
      buses: true,
      trains: true,
      ferries: true,
      cableCar: true,
      modeSpecificClassification: true,
      vehicleTracking: true,
      tripTracking: true,
      serviceAlerts: true,
      dataRepair: true,
      snapper: true,
      schoolRoutes: true,
      cruiseships: true,
      stationPlatforms: true,
      busRegistrationLookup: true,
      mapAddressSearch: true,
    },
    automation: {
      serviceAlertsCron: true,
      tripUpdatesCron: true,
      stationPlatformsCron: true,
      observedVehiclesCron: true,
    },
  },
  chch: {
    id: "chch",
    label: "Christchurch",
    domain: "chch.catchy.nz",
    allowedOrigin: "https://chch.catchy.nz",
    timezone: "Pacific/Auckland",
    map: {
      center: [172.6362, -43.5321],
      bounds: [172.2, -43.8, 173.0, -43.2],
    },
    branding: {
      appName: "Catchy Christchurch",
      storagePrefix: "chch",
    },
    publicPages: {
      aboutDescription:
        "Find out more about Christchurch's favourite free public transport app.",
      agencyName: "Metro",
      modesLabel: "buses and ferries",
      appsDescription:
        "Apps are available for Android and iPhone, with Apple Watch and Wear OS companion apps.",
      googlePlayUrl:
        "https://play.google.com/store/apps/details?id=nz.catchy.chch.twa",
      appleStoreUrl:
        "https://apps.apple.com/nz/app/catchy-christchurch/id6445872676",
      includeWatchCredit: true,
      includeWearCredit: true,
      dataCredits: [
        {
          name: "Metro",
          href: "https://www.metroinfo.co.nz/",
          apiHref: "https://apidevelopers.metroinfo.co.nz/",
        },
      ],
    },
    data: {
      provider: "metroinfo",
      databaseEnv: "POSTGRESQL_CONNECTION_STRING",
      gtfsSchema: "gtfs_christchurch",
      regionSchema: "christchurch",
      searchPath: "gtfs_christchurch,christchurch,shared,public",
      hasRealtimeIngest: false,
      hasDataRepairLayer: true,
    },
    capabilities: {
      realtime: true,
      staticGtfsOnly: false,
      buses: true,
      trains: false,
      ferries: true,
      cableCar: false,
      modeSpecificClassification: false,
      vehicleTracking: true,
      tripTracking: true,
      serviceAlerts: true,
      dataRepair: true,
      snapper: false,
      schoolRoutes: false,
      cruiseships: false,
      stationPlatforms: false,
      busRegistrationLookup: true,
      mapAddressSearch: true,
    },
    automation: {
      serviceAlertsCron: true,
      tripUpdatesCron: false,
      stationPlatformsCron: false,
      observedVehiclesCron: true,
    },
  },
  otago: {
    id: "otago",
    label: "Otago",
    domain: "otago.catchy.nz",
    allowedOrigin: "https://otago.catchy.nz",
    timezone: "Pacific/Auckland",
    map: {
      center: [170.5028, -45.8788],
      bounds: [169.8, -46.4, 171.2, -45.3],
    },
    branding: {
      appName: "Catchy Otago",
      storagePrefix: "otago",
    },
    publicPages: {
      aboutDescription:
        "Find out more about Otago's free public transport app.",
      agencyName: "Otago Regional Council",
      modesLabel: "buses and ferries",
      appsDescription:
        "Apps are available for Android and iPhone, with Apple Watch and Wear OS companion apps.",
      googlePlayUrl:
        "https://play.google.com/store/apps/details?id=nz.catchy.otago.android&hl=en_NZ",
      appleStoreUrl:
        "https://apps.apple.com/nz/app/catchy-otago/id6768014160",
      includeWatchCredit: true,
      includeWearCredit: true,
      dataCredits: [
        {
          name: "Otago Regional Council",
          href: "https://www.orc.govt.nz/",
          apiHref: "https://www.orc.govt.nz/public-transport/",
        },
      ],
    },
    data: {
      provider: "orc",
      databaseEnv: "POSTGRESQL_CONNECTION_STRING",
      gtfsSchema: "gtfs_otago",
      regionSchema: "otago",
      searchPath: "gtfs_otago,otago,shared,public",
      hasRealtimeIngest: true,
      hasDataRepairLayer: true,
    },
    capabilities: {
      realtime: true,
      staticGtfsOnly: false,
      buses: true,
      trains: false,
      ferries: true,
      cableCar: false,
      modeSpecificClassification: false,
      vehicleTracking: true,
      tripTracking: true,
      serviceAlerts: false,
      dataRepair: true,
      snapper: false,
      schoolRoutes: false,
      cruiseships: false,
      stationPlatforms: false,
      busRegistrationLookup: true,
      mapAddressSearch: true,
    },
    automation: {
      serviceAlertsCron: false,
      tripUpdatesCron: false,
      stationPlatformsCron: false,
      observedVehiclesCron: true,
    },
  },
  generic_static: {
    id: "generic_static",
    label: "Generic Static GTFS Region",
    domain: "static.catchy.nz",
    allowedOrigin: "https://static.catchy.nz",
    timezone: "Pacific/Auckland",
    map: {
      center: [174.0, -41.0],
      bounds: [166.0, -47.5, 179.0, -34.0],
    },
    branding: {
      appName: "Catchy Static",
      storagePrefix: "static",
    },
    data: {
      provider: "generic-static",
      databaseEnv: "POSTGRESQL_CONNECTION_STRING",
      gtfsSchema: "gtfs_generic_static",
      regionSchema: "generic_static",
      searchPath: "gtfs_generic_static,generic_static,shared,public",
      hasRealtimeIngest: false,
      hasDataRepairLayer: false,
    },
    capabilities: {
      realtime: false,
      staticGtfsOnly: true,
      buses: true,
      trains: false,
      ferries: false,
      cableCar: false,
      modeSpecificClassification: false,
      vehicleTracking: false,
      tripTracking: false,
      serviceAlerts: false,
      dataRepair: false,
      snapper: false,
      schoolRoutes: false,
      cruiseships: false,
      stationPlatforms: false,
      busRegistrationLookup: false,
      mapAddressSearch: false,
    },
    automation: {
      serviceAlertsCron: false,
      tripUpdatesCron: false,
      stationPlatformsCron: false,
      observedVehiclesCron: false,
    },
  },
  auckland: {
    id: "auckland",
    label: "Auckland",
    domain: "auckland.catchy.nz",
    allowedOrigin: "https://auckland.catchy.nz",
    timezone: "Pacific/Auckland",
    map: {
      center: [174.7633, -36.8485],
      bounds: [174.1, -37.4, 175.5, -36.1],
    },
    branding: {
      appName: "Catchy Auckland",
      storagePrefix: "akl",
    },
    publicPages: {
      aboutDescription:
        "Find out more about Auckland's free public transport app.",
      agencyName: "Auckland Transport",
      modesLabel: "buses, trains, and ferries",
      appsDescription:
        "Apps are available for Android and iPhone, with an Apple Watch companion app.",
      googlePlayUrl:
        "https://play.google.com/store/apps/details?id=nz.catchy.auckland.android",
      appleStoreUrl:
        "https://apps.apple.com/nz/app/catchy-auckland/id6780354056",
      includeWatchCredit: true,
      dataCredits: [
        {
          name: "Auckland Transport",
          href: "https://at.govt.nz/",
          apiHref: "https://dev-portal.at.govt.nz/",
        },
      ],
    },
    data: {
      provider: "at",
      databaseEnv: "POSTGRESQL_CONNECTION_STRING",
      gtfsSchema: "gtfs_auckland",
      regionSchema: "auckland",
      searchPath: "gtfs_auckland,auckland,shared,public",
      hasRealtimeIngest: false,
      hasDataRepairLayer: true,
    },
    capabilities: {
      realtime: true,
      staticGtfsOnly: false,
      buses: true,
      trains: true,
      ferries: true,
      cableCar: false,
      modeSpecificClassification: true,
      vehicleTracking: true,
      tripTracking: true,
      serviceAlerts: true,
      dataRepair: true,
      snapper: false,
      schoolRoutes: false,
      cruiseships: false,
      stationPlatforms: false,
      busRegistrationLookup: false,
      mapAddressSearch: true,
    },
    automation: {
      serviceAlertsCron: true,
      tripUpdatesCron: false,
      stationPlatformsCron: false,
      observedVehiclesCron: true,
    },
  },
};

const REGION_DEV_PORTS = {
  wellington: 3030,
  chch: 3031,
  otago: 3032,
  auckland: 3033,
};

export const DEFAULT_REGION_ID = "wellington";

export function getRegionIdFromEnv() {
  const rawRegion = process.env.CATCHY_REGION?.trim().toLowerCase();
  return REGION_DEFINITIONS[rawRegion] ? rawRegion : DEFAULT_REGION_ID;
}

export function getRegionConfig(regionId = getRegionIdFromEnv()) {
  return REGION_DEFINITIONS[regionId] ?? REGION_DEFINITIONS[DEFAULT_REGION_ID];
}

export function listRegionConfigs() {
  return Object.values(REGION_DEFINITIONS);
}

function normalizeOrigin(value) {
  const origin = String(value || "").trim();

  if (!origin) {
    return null;
  }

  const withProtocol = /^https?:\/\//i.test(origin)
    ? origin
    : `https://${origin}`;

  try {
    return new URL(withProtocol).origin;
  } catch {
    return null;
  }
}

export function getRegionOrigin(regionId = getRegionIdFromEnv()) {
  return getRegionConfig(regionId).allowedOrigin;
}

export function getPublicOrigin(regionId = getRegionIdFromEnv()) {
  const explicitOrigin =
    normalizeOrigin(process.env.CATCHY_SITE_URL) ||
    normalizeOrigin(process.env.NEXT_PUBLIC_SITE_URL) ||
    normalizeOrigin(process.env.CATCHY_PUBLIC_ORIGIN);

  if (explicitOrigin) {
    return explicitOrigin;
  }

  if (process.env.NODE_ENV === "development") {
    const port = process.env.PORT || REGION_DEV_PORTS[regionId] || 3000;

    return `http://localhost:${port}`;
  }

  if (process.env.VERCEL_ENV && process.env.VERCEL_ENV !== "production") {
    return normalizeOrigin(process.env.VERCEL_URL) || getRegionOrigin(regionId);
  }

  return (
    normalizeOrigin(process.env.VERCEL_PROJECT_PRODUCTION_URL) ||
    getRegionOrigin(regionId)
  );
}

export function getRequestOrigin(request, regionId = getRegionIdFromEnv()) {
  try {
    return new URL(request?.url).origin;
  } catch {
    return getPublicOrigin(regionId);
  }
}
